import { Component, Input, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { resumeDataInterface } from '../../interfaces/resume';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'mcrit-gestio-concursos-resume',
  templateUrl: './concursos.resume.component.html',
  styleUrls: ['./concursos.resume.component.css']
})
export class ConcursosResumeComponent implements OnInit {
  @Input() dades: resumeDataInterface;
  @Input() titol: string;

  constructor(public translate: TranslateService, public languageService: LanguageService){}

  ngOnInit(){}

}
